import { useState } from "react";
import { useIsMobile } from "@/hooks/use-mobile";
import MobileBottomNav from "@/components/mobile/MobileBottomNav";
import MobileSideMenu from "@/components/mobile/MobileSideMenu";
import FeedbackButton from "@/components/FeedbackButton";
import SiteFooter from "@/components/SiteFooter";


interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const isMobile = useIsMobile();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      <MobileSideMenu open={mobileMenuOpen} onOpenChange={setMobileMenuOpen} />
      
      <main className="container mx-auto px-4 py-8 pb-32 md:pb-36">
        {children}
        <SiteFooter />
      </main>

      <MobileBottomNav onMenuClick={() => setMobileMenuOpen(true)} />
      <FeedbackButton />
    </div>
  );

};

export default Layout;
